<template>
    <div class="vue-marker-mini-card" @click.prevent="handleClick">
        <div class="row mx-0 d-flex align-center justify-content-center">
            <div class="distance col-auto pl-0 pr-4 d-inline-flex flex-column align-items-center justify-content-center" v-if="hasDistance">
                <span class="kilometers font-weight-bold">{{ marker.distanceFormatted }}</span>
                <span class="unit">km</span>
            </div>

            <div class="col pl-0 pr-10 info-wrapper">
                <h3 class="virtual-p mb-0 font-weight-bold"><button @click="handleClick">{{ marker.title }}</button></h3>
                <p>{{ marker.streetNumber }}<br> {{ marker.postalCodePlace }}</p>

                <p class="office-hours-mini mb-0">
                    <template v-if="isOpen && currentSlot">
                        <span class="font-weight-bold">{{ openText }}</span>
                        {{ currentSlot }}
                    </template>

                    <template v-else>
                        {{ closedText }}
                    </template>
                </p>

                <template v-if="parsedPhonenumber">
                    <p>Tel: <a :href="`tel:${parsedPhonenumber}`">{{ marker.tel }}</a><br></p>
                </template>
            </div>
        </div>

        <span class="right-top-c2a">Kies garage</span>
    </div>
</template>

<script>
import parsePhoneNumber from './../../../../../themes/custom/ef2_custom/node_modules/libphonenumber-js';
import OpeningHours from "../mixins/OpeningHours";

export default {
    name: "MarkerMiniCard",

    mixins: [OpeningHours],

    props: {
        marker: {
            type: Object,
            required: true
        },
        eventBus: {},
        modalBus: {}
    },

    computed:{
        hasDistance() {
            return !lodash.isNil(this.marker.distanceFormatted);
        },

        parsedPhonenumber() {
            if (_.isEmpty(this.marker.tel)) {
                return;
            }

            return parsePhoneNumber(this.marker.tel, 'NL').number;
        },
    },

    methods: {
        handleClick() {
            this.$emit('marker-clicked', this.marker.geolocation);
            this.$emit('active-marker', this.marker);
        },
    }
}
</script>